import { render, staticRenderFns } from "./blockGeneralSettings.vue?vue&type=template&id=2d57ab4c&scoped=true&"
import script from "./blockGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./blockGeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockGeneralSettings.vue?vue&type=style&index=0&id=2d57ab4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57ab4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
